/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const SmallTitle = styled.div`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
export const ChangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;
export const ValuesContainer = styled.div`
  display: flex;
`;
export const OldValue = styled.span`
  color: ${Palette.Red._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding-right: 8px;
`;

export const NewValue = styled.span`
  color: ${Palette.Green._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding-right: 8px;
  padding-left: 8px;
`;
